import { noop } from '../../utils/noop.js';
export const selectedItemLabel = (selectedItem, defaultValue = '') => {
    if (Array.isArray(selectedItem))
        return selectedItem.map((item) => item.children || item.value).join(', ');
    if (selectedItem?.children)
        return selectedItem?.children;
    if (selectedItem?.value !== undefined) {
        // TODO: fix this horrible hack
        if (typeof selectedItem.value === 'object') {
            return JSON.stringify(selectedItem.value, null, 2);
        }
        return selectedItem.value;
    }
    return defaultValue;
};
export const isDomElement = (type) => {
    return /button|div|span/.test(type ?? '');
};
export const onSelectedItemChange = ({ changes, enableMultiSelect, selectedItems, selectedValues, onChange = noop, selectAllItem, allSelected, itemsForSelectAll }) => {
    const { selectedItem, type } = changes;
    /* istanbul ignore if */
    if (!selectedItem) {
        return;
    }
    if (enableMultiSelect) {
        const index = selectedValues.indexOf(selectedItem.value);
        const itemAlreadySelected = index >= 0;
        if (selectedItem === selectAllItem) {
            const selectAllValues = itemsForSelectAll.map((item) => item.value);
            onChange?.({
                type,
                selectedItem: selectAllItem,
                selectedItems: !allSelected
                    ? [
                        ...selectedItems,
                        ...itemsForSelectAll.filter((item) => !item.disabled && !selectedValues.includes(item.value))
                    ]
                    : selectedItems.filter((item) => !selectAllValues.includes(item.value))
            });
        }
        else if (itemAlreadySelected) {
            onChange({
                ...changes,
                selectedItem: selectedItem,
                selectedItems: [...selectedItems.slice(0, index), ...selectedItems.slice(index + 1)].filter(Boolean)
            });
        }
        else {
            onChange({
                ...changes,
                selectedItem: selectedItem,
                selectedItems: [...selectedItems, selectedItem]
            });
        }
    }
    else {
        if (selectedItem?.value === '') {
            onChange({
                ...changes,
                selectedItem: {},
                selectedItems: []
            });
        }
        else {
            onChange({
                ...changes,
                selectedItem: selectedItem,
                selectedItems: [selectedItem]
            });
        }
    }
};
export const sortBySelected = (selectedValues) => (itemA, itemB) => {
    const itemASelected = selectedValues?.includes(itemA.value);
    const itemBSelected = selectedValues?.includes(itemB.value);
    return itemASelected === itemBSelected ? 0 : itemASelected ? -1 : 1;
};
//# sourceMappingURL=utils.js.map